var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("strong", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "testEquipment.measurementSpecification.measurementSpecifications"
            )
          )
        )
      ]),
      _vm._v(" "),
      _vm.showTemplateNames
        ? _c("MeasurementSpecificationsTemplateBadges", {
            attrs: { measurementSpecifications: _vm.rows }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("VueGoodTable", {
        ref: "table",
        attrs: {
          columns: _vm.columns,
          rows: _vm.rows,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        on: { "on-row-click": _vm.onClick },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.type === "boolean"
                  ? _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        staticClass: "form-check-input",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: props.formattedRow[props.column.field]
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                          }
                        }
                      })
                    ])
                  : props.column.field === "actions"
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "btn-group",
                          attrs: {
                            role: "group",
                            "aria-label": "Basic example"
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.onEdit(props.row)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-pen" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger btn-sm",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.onDelete(props.row)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-trash-alt" })]
                          )
                        ]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.editable
        ? [
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success btn-sm mt-2",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onNew()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn-sm mt-2",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onTemplateChoose.apply(null, arguments)
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-file" })]
              )
            ]),
            _vm._v(" "),
            _c("TestEquipmentMeasurementSpecificationEditModal", {
              ref: "editModal",
              on: { save: _vm.saveSpecification }
            }),
            _vm._v(" "),
            _c("MeasurementSpecificationTemplateSelectionModal", {
              ref: "selectModal",
              on: { selected: _vm.onTemplateChosen }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }